import React from 'react';
import SMSearchFormBaseView from 'components/search/SMSearchFormBaseView';

class SMHomeSearchFormView extends SMSearchFormBaseView {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.priceType !== nextProps.priceType){
      this.setState({priceType: nextProps.priceType});
    }
  }

  render() {

    let responsiveClass={};
    switch (this.state.priceType) {
      case 'hourly':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-4',
          priceType: 'col-xs-3 col-sm-3 col-md-1',
          start: 'col-xs-6 col-sm-6 col-md-3',
          end: '',
          capacity: 'col-xs-6 col-sm-6 col-md-2 search-filter__person-num',
        };
        break;
      case 'stay':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-4',
          priceType: '',
          start: 'col-xs-6 col-sm-6 col-md-2',
          end: 'col-xs-6 col-sm-6 col-md-2',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
        break;
      default:
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-3',
          priceType: 'col-xs-3 col-sm-3 col-md-1',
          start: 'col-xs-6 col-sm-6 col-md-2',
          end: 'col-xs-6 col-sm-6 col-md-2',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
    }
    const calendarClass = this.props.group == 1 ?
      'datetime-layout clearfix' : 'datetime-layout datetime-layout__low clearfix';

    return (
      <div className="container">
        <div className="row">
          <input type="hidden" name="event_type" value={this.props.eventType} />
          {this.renderAreaField(responsiveClass.area, 'location')}
          {this.renderPriceTypeSelect(responsiveClass.priceType)}
          {this.renderStartedAtField(responsiveClass.start)}
          {this.renderEndedAtField(responsiveClass.end)}
          {this.renderCapacityRange(responsiveClass.capacity)}
          <div className="col-xs-12 col-sm-12 col-md-2">
            <div className="search-box-button-area">
              <input className="form-btn form-btn__blue form-btn-top" name="" type="submit" value="検索" />
            </div>
          </div>
          {this.renderDatePicker(calendarClass)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomeSearchFormView.jsx